import { Branded } from '@/lib/utils/brand'
import { z } from 'zod'

export type PrinterAddress = Branded<string, 'PrinterAddress'>
export type StationNumeric = Branded<string, 'StationNumeric'>

export const PrinterAddressSchema = z
  .string()
  .regex(/^[0-9A-F]{6}$/)
  .transform((value) => value as PrinterAddress)

export const StationNumericSchema = z
  .string()
  .regex(/^[0-9]{8}$/)
  .transform((value) => value as StationNumeric)
